// extracted by mini-css-extract-plugin
export default {"roundedCircle":"Wallet_roundedCircle__QJzXD","walletLogo":"Wallet_walletLogo__cJupH"};